var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-6 chart-container",staticStyle:{"position":"relative","height":"400px"}},[_c('canvas',{ref:"graphChart"})])
}
var staticRenderFns = []

export { render, staticRenderFns }